import React, { useState } from 'react'
import { useMutation } from '@apollo/client'
import Button from '../../components/atoms/Buttons'
import { REFUND_BOOKING_DEPOSIT } from '../../apollo/mutations/booking'
import './style.css'

const RefundConfirmationModal = ({ booking, onClose, onDone }) => {
  const [errorText, setErrorText] = useState('')
  const [refund, { loading }] = useMutation(REFUND_BOOKING_DEPOSIT, {
    refetchQueries: ['listBookingsByDate'],
  })

  const submit = async () => {
    try {
      await refund({ variables: { id: booking.id } })
      onDone?.()
    } catch (err) {
      setErrorText(err?.message || 'Refund failed.')
    }
  }

  const amount = booking.depositAmount ? `$${(booking.depositAmount / 100).toFixed(2)}` : '$0.00'

  return (
    <div>
      <div className="booking-modal-backdrop" onClick={onClose} />
      <div className="booking-modal-container" style={{ maxWidth: 440, width: '92%' }}>
        <h2 className="add-events !text-[24px] !mt-0 mb-2">Refund + Cancel?</h2>
        <p className="text-[14px] font-montserrat text-[#343434] mb-4">
          Refund <strong>{amount}</strong> to <strong>{booking.customerName}</strong> and cancel this
          booking? This is irreversible — the slot will reopen and a cancellation email will be sent.
        </p>
        {errorText && <div className="text-[13px] text-[color:var(--color-primary-danger)] mb-3">{errorText}</div>}
        <div className="flex gap-x-3 justify-center">
          <Button type="button" loading={loading} onClick={submit} primary className="!bg-[color:var(--color-primary-danger)]">
            Refund + Cancel
          </Button>
          <Button type="button" onClick={onClose} primaryOutline>
            Keep Booking
          </Button>
        </div>
      </div>
    </div>
  )
}

export default RefundConfirmationModal
